
import angular from 'angular';
import { DatalayerConstantsType } from 'ib-web-commons/dist/ib-datalayer/ib-datalayer-constants';

import { CommonsSessionStorageService } from 'ib-web-commons/dist/utils';
import { DatalayerUtils } from 'src/app/shared/ib-datalayer-utils';

const componentOptions = {
    bindings: {
        modules: '=',
        index: '=',
        last: '='
    },
    controllerAs: 'ibGlobickActivitiesBoxCtrl',
    templateUrl: ['$rootScope', function ($rootScope) {
        return $rootScope.routes.templates + 'ib-globick-activities-box-view.html';
    }]
};


const componentInfo = {
    module: 'ib-globick-activities-box-module',
    selector: 'ibGlobickActivitiesBox',
    inject: [
        '$scope',
        '$rootScope',
        'CommonsSessionStorageService',
        'DatalayerUtils',
        'DatalayerConstants',
        'CommonsAncillariesService'
    ],
    required: ['']
};

export class ibGlobickActivitiesBox implements ng.IController {

    public confirmed: boolean;

    constructor (
        private $scope: angular.IScope,
        private $rootScope: CommonsRootScope,
        private CommonsSessionStorageService: CommonsSessionStorageService,
        private DatalayerUtils: DatalayerUtils,
        private DatalayerConstants: DatalayerConstantsType,
        private CommonsAncillariesService: CommonsAncillariesService
    ) {
        const headerModel:any = this.CommonsSessionStorageService.get('headerModel');
        if (this.CommonsSessionStorageService.get('globickActivitieBuyed')) {
            this.CommonsSessionStorageService.remove('globickActivitieBuyed');
            this.confirmed = true;
        } else if (headerModel?.headerModel?.shoppingBasket.globickActivities.hasActivitiesGlobick) {
            this.confirmed = true;
        } else {
            this.confirmed = false;
        }
        this.$scope.$on('setConfirmed', this.setConfirmed);
        this.$rootScope.$on('deleteGlobickActivities', this.deleteGlobickActivities);
        this.$rootScope.$on('updateArrayActivities', this.updateArrayActivities);
    }

    /**
     * Emit event to parent for open modal of activities
    */
    openModal = (): void => {
        if (!this.confirmed) {
            this.$scope.$emit('openActivitiesModal');
        }else {
            this.$scope.$emit('openActivitiesModifyModal');
        }
        this.CommonsAncillariesService.registerClickGlobickProduct('EXP');
    };

    /*
    *
    */
    setConfirmed = () => {
        this.confirmed = true;
    };

    /*
    *
    */
    setDisconfirmedActivities = () => {
        this.confirmed = false;
    };

    deleteGlobickActivities = (event: any, model: any) => {
        //Add datalayer remove_from_cart
        //this.DatalayerUtils.setActivitiesEvent(this.DatalayerConstants.EVENTS_ECOMMERCE.REMOVE_FROM_CART, undefined, model.info.description);
        this.setDisconfirmedActivities();
    };

    updateArrayActivities = (index) => {
        this.$scope.$emit('updateArrayActivities', index);
    };

}

try {
    const mod = angular.module(componentInfo.module);
    let moduleOrNname: string;
    ibGlobickActivitiesBox.$inject = componentInfo.inject;
    mod.component(
        componentInfo.selector,
        angular.extend(componentOptions, { controller: ibGlobickActivitiesBox })
    );
} catch (error) {
    const mod = angular.module(componentInfo.module, componentInfo.required);
    ibGlobickActivitiesBox.$inject = componentInfo.inject;
    mod.component(
        componentInfo.selector,
        angular.extend(componentOptions, { controller: ibGlobickActivitiesBox})
    );
}